<template>
  <div class="answer_box">
    <div class="plate_wrapper">
        <div class="plate_box">
            <div class="plate">
                <img :src="`${publicPath}/images/plate.svg`">
            </div>
        </div>
    </div>
    <div class="answer_wrapper">
        <div class="answer_box">
            <div class="answer">
              <img v-if="plateNumber >= 0" :src="answerImagePath(answerName)">
              <span v-else :class="customClassName(answerIndex)">{{ answerName }}</span>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnswerComponent',
  props: {
    answerName: {
      default: '',
      type: String
    },
    answerIndex: {
      default: 0,
      type: Number
    },
    plateNumber: {
      default: 0,
      type: Number
    }
  }
}
</script>
